// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5e8d0d0b","455":"798f226a","977":"4bd5d2a7"}[chunkId] + ".chunk.js";
};